export const facebookProfileURLRegex =
    /^https?:\/\/(www\.)?facebook\.com\/.+$/i;
export const instagramProfileURLRegex =
    /^https?:\/\/(www\.)?instagram\.com\/.+$/i;

export const emailRegex = /^\w+([\.+-]?\w+)*\+*@\w+([\.-]?\w+)*(\.\w{2,})+$/;

export const urlWithOptionalProtocolRegex =
    /^(https?:\/\/)?([\w-]+\.)+[\w-]+(:\d+)?(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;
